import React from 'react';
const stepsStyle = {
  textAlign: 'justify',
  fontSize: '1.2rem'
};

export const matrixSLATourSteps = [
  {
    selector: '.needs-validation',
    content: `Olá seja bem vindo ao nosso Tour Guiado, aqui você vai aprender como funciona a criação de uma matriz SLA`,
    style: stepsStyle
  },
  {
    selector: '.needs-validation',
    content: `Primeiramente, o que é uma matriz SLA? Uma matriz SLA é um conjunto de regras que determinam o tempo de atendimento de um chamado, ou seja, é um conjunto de regras que determinam o tempo máximo que um chamado pode ficar sem ser atendido.`,
    style: stepsStyle
  },
  {
    selector: '.tour1-dt',
    content: `Nome, esse é o nome da matriz SLA, ele é obrigatório e vai servir como identificador da matriz SLA.`,
    style: stepsStyle
  },
  {
    selector: '.tour2-dt',
    content: `
      Categoria dos Clientes, descrever o papel das categorias
    `,
    style: stepsStyle
  },
  {
    selector: '.tour3-dt',
    content: `
      Agora, vamos falar sobre a Matriz SLA em si, a matriz SLA é composta por 2 campos:
    `,
    style: stepsStyle
  },
  {
    selector: '.tour4-dt',
    content: () => (
      <div>
        <b>Impactos: </b> O impacto é o quanto um chamado afeta o negócio, ele é
        dividido em 4 níveis, sendo eles:
        <ul>
          <li>Alto</li>
          <li>Médio</li>
          <li>Baixo</li>
          <li>Crítico</li>
        </ul>
        <br />
        <b>Criticidade: </b> A criticidade é o quanto um chamado é importante
        para o negócio, ela é dividida em 4 níveis, sendo eles:
        <ul>
          <li>Alto</li>
          <li>Médio</li>
          <li>Baixo</li>
          <li>Crítico</li>
        </ul>
      </div>
    ),
    style: stepsStyle
  },
  {
    selector: '.tour5-dt',
    content: `
      Você pode adicionar ou remover criticidade adicionar ou remover.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour6-dt',
    content: `
      Assim como você pode adicionar ou remover impactos.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour7-dt',
    content: () => (
      <div>
        Em cada célula da matriz SLA, você pode definir 2 tipos de SLA:
        <br />
        <b>SLA de atendimento: </b> O SLA de atendimento é o tempo máximo que um
        chamado pode ficar sem ser atendido
        <br />
        <b>SLA de solução: </b> O SLA de solução é o tempo máximo que um chamado
        pode ficar sem ser resolvido,
      </div>
    ),
    style: stepsStyle
  },
  {
    selector: '.tour8-dt',
    content: `
      Os valores das células são representado em minutos, portanto, o
      valor deve ser um número inteiro. ex: 30, 60, 90, 120, etc, sendo que 30
      minutos é o mesmo que meia hora, 60 minutos é o mesmo que 1 hora, 90
      minutos é o mesmo que 1 hora e meia, e assim por diante.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour9-dt',
    content: `
      Os valores padrões da matriz sao obrigatórios e servem para o cenário onde não há uma regra específica para um determinado impacto e criticidade, como um protocol sem motivo ou submotivo.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour10-dt',
    content: `
      O horário de funcionamento da matriz representa quais dias e horários a matriz SLA está ativa, ou seja, somente nesse dias e horários o tempo de atendimento e solução dos chamados será contabilizado.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour11-dt',
    content: `
      Ao ativar o timer sequencial, o tempo de atendimento e solução dos chamados será contabilizado de forma sequencial, ou seja, o tempo de atendimento e solução dos chamados será contabilizado de forma contínua, sem interrupções.
    `,
    style: stepsStyle
  }
];

export const matrixSLAHolidaysTourSteps = [
  {
    selector: '.needs-validation',
    content: `Olá seja bem vindo ao nosso Tour Guiado, aqui você vai aprender como funciona a criação de um feriado para a matriz SLA`,
    style: stepsStyle
  },
  {
    selector: '.needs-validation',
    content: `Primeiramente, o que é um feriado? Um feriado é um dia em que a empresa não trabalha, ou seja, é um dia em que a empresa não atende chamados.`,
    style: stepsStyle
  },
  {
    selector: '.tour1-dt_matrix_sla_holidays',
    content: `Nome, esse é o nome do feriado, ele é obrigatório e vai servir como identificador do feriado.`,
    style: stepsStyle
  },
  {
    selector: '.tour2-dt_matrix_sla_holidays',
    content: `
      Descrição, a descrição é um campo opcional, ele serve para descrever o feriado, ou seja, serve para dizer o motivo do feriado.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour3-dt_matrix_sla_holidays',
    content: `
      Data, a data é o dia do feriado, ela é obrigatória e serve para dizer em que dia o feriado ocorre.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour4-dt_matrix_sla_holidays',
    content: `
      Hora de início, a hora de início é a hora em que o feriado começa, ela é opcional e serve para dizer a que horas o feriado começa.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour5-dt_matrix_sla_holidays',
    content: `
      Hora de término, a hora de término é a hora em que o feriado termina, ela é opcional e serve para dizer a que horas o feriado termina.
    `,
    style: stepsStyle
  }
];

export const matrixSLAServiceClassificationsTourSteps = [
  {
    selector: '.needs-validation',
    content: `Olá seja bem vindo ao nosso Tour Guiado, aqui você vai aprender sobre as classificações de serviço da matriz SLA`,
    style: stepsStyle
  },
  {
    selector: '.needs-validation',
    content: `Primeiramente, o que é uma classificação de serviço? Uma classificação de serviço é um conjunto de regras que determinam o tempo de atendimento de um chamado.`,
    style: stepsStyle
  },
  {
    selector: '.tour-dt_matrix_sla_service_classifications_quantity',
    content: `Toda Matriz SLA tem um conjunto de classificações de serviço, cada classificação de serviço é composta por 2 campos:
      'impacto' e 'criticidade'. Que representam os valores preenchidos na matriz SLA.`,
    style: stepsStyle
  },
  {
    selector:
      '.tour-dt_matrix_sla_service_classifications_quantity_possible_values',
    content: `
      Esse campo é o número de classificações de serviço que a matriz SLA pode ter.
    `,
    style: stepsStyle
  },
  {
    selector:
      '.tour-dt_matrix_sla_service_classifications_quantity_current_values',
    content: `
      Esse campo é o número de classificações de serviço que já foram preenchidas.
    `,
    style: stepsStyle
  },
  {
    selector: '.tour1-dt_matrix_sla_service_classifications',
    content: `Clique em alguma das classificações de serviço, e clique em 'Saiba Mais' para mais detalhes`,
    style: stepsStyle
  }
];

export const matrixSLAServiceClassificationsTourStepsInsideModal = [
  {
    selector: '.tour-dt_matrix_sla_service_classifications_modal',
    content: `Nome, representa o nome da sua classificação de serviço, por padrão ele é o conjunto entre os nomes dos impactos e criticidades, no formato 'impacto > criticidade', mas você pode colocar o nome que quiser!`,
    style: stepsStyle
  },
  {
    selector: '.tour-dt_matrix_sla_service_classifications_modal_reason',
    content: `
    Motivo, o campo motivo é obrigatório e serve para descrever o motivo da classificação de serviço
    `,
    style: stepsStyle
  },
  {
    selector: '.tour-dt_matrix_sla_service_classifications_modal_subreason',
    content: `Submotivo, o campo submotivo é opcional e serve para descrever o submotivo da classificação de serviço`,
    style: stepsStyle
  },
  {
    selector: '.tour-dt_matrix_sla_service_classifications_modal_add_reason',
    content: `Aqui voce pode adicionar um novo conjunto de motivos e submotivos`,
    style: stepsStyle
  },
  {
    selector: '.tour-dt_matrix_sla_service_classifications_modal_remove_reason',
    content: `Aqui voce pode remover um conjunto de motivos e submotivos`,
    style: stepsStyle
  }
];
